import template from './swag-cms-extensions-form-editor-group.html.twig';
import './swag-cms-extensions-form-editor-group.scss';

export default {
    name: 'swag-cms-extensions-form-editor-group',

    template,

    inject: [
        'repositoryFactory',
    ],

    mixins: [
        'cms-state',
        'position',
        'swag-cms-extensions-form-group-field-error',
    ],

    props: {
        group: {
            type: Object,
            required: true,
        },

        groupCount: {
            type: Number,
            required: true,
        },
    },

    computed: {
        activeItem() {
            return Shopware.Store.get('swCmsDetailCurrentCustomForm').activeItem;
        },

        form() {
            return Shopware.Store.get('swCmsDetailCurrentCustomForm').form;
        },

        groupHasError() {
            return !!Shopware.Store.get('error').getErrorsForEntity(
                'swag_cms_extensions_form_group',
                this.group.id,
            );
        },

        formGroupRepository() {
            return this.repositoryFactory.create('swag_cms_extensions_form_group');
        },

        formFieldRepository() {
            return this.repositoryFactory.create('swag_cms_extensions_form_group_field');
        },

        isActive() {
            return this.group.id === this.activeItem.id;
        },

        groupDragData() {
            return {
                delay: 200,
                dragGroup: 'editor-group',
                data: { group: this.group },
                onDragEnter: this.onGroupDragSort,
                onDrop: this.onGroupDragStop,
            };
        },

        groupDropData() {
            return {
                dragGroup: 'editor-group',
                data: { group: this.group },
            };
        },
    },

    methods: {
        onAddField() {
            Shopware.Store.get('swCmsDetailCurrentCustomForm').addField(
                this.group.id,
                this.formFieldRepository,
                Shopware.Context.api,
                this.$tc('swag-cms-extensions.sw-cms.components.form-editor.group.field.fieldPrefix'),
            );

            this.validateDuplicateTechnicalName(this.form, this.group.fields.last());
        },

        onTitleClick() {
            Shopware.Store.get('swCmsDetailCurrentCustomForm').activeItem = this.group;
        },

        onMoveUp() {
            Shopware.Store.get('swCmsDetailCurrentCustomForm').moveItem(this.group.id, this.lowerPositionValue);
        },

        onMoveDown() {
            Shopware.Store.get('swCmsDetailCurrentCustomForm').moveItem(this.group.id, this.raisePositionValue);
        },

        onDuplicate() {
            const store = Shopware.Store.get('swCmsDetailCurrentCustomForm');

            store.addGroup(
                this.formGroupRepository,
                this.$tc('swag-cms-extensions.sw-cms.components.form-editor.group.groupNamePrefix'),
                Shopware.Context.api,
            );

            store.duplicateGroup(
                this.group.id,
                this.formFieldRepository,
                Shopware.Context.api,
            );
        },

        onDelete() {
            const fieldIds = this.group.fields.map(field => field.id);

            Shopware.Store.get('swCmsDetailCurrentCustomForm').deleteGroup(this.group.id);

            // Remove errors in state for fields in group
            fieldIds.forEach((fieldId) => {
                const errors = Shopware.Store.get('error').getErrorsForEntity(
                    'swag_cms_extensions_form_group_field',
                    fieldId,
                );

                if (!errors) {
                    return;
                }

                Object.keys(errors).forEach((key) => {
                    Shopware.Store.get('error').removeApiError(errors[key].selfLink);
                });
            });

            // Remove errors in state for the group
            const errors = Shopware.Store.get('error').getErrorsForEntity(
                'swag_cms_extensions_form_group',
                this.group.id,
            );

            if (!errors) {
                return;
            }

            Object.keys(errors).forEach((key) => {
                Shopware.Store.get('error').removeApiError(errors[key].selfLink);
            });
        },

        onGroupDragStop() {
            Shopware.Store.get('swCmsDetailCurrentCustomForm').setGroupProperty(
                this.group.id,
                'isDragging',
                false,
            );
        },

        onGroupDragSort(dragData, dropData, validDrop) {
            if (!validDrop) {
                return;
            }

            if (dragData.group.position !== dropData.group.position) {
                Shopware.Store.get('swCmsDetailCurrentCustomForm').setGroupProperty(
                    this.group.id,
                    'isDragging',
                    true,
                );

                Shopware.Store.get('swCmsDetailCurrentCustomForm').setItemPosition(
                    dragData.group.id,
                    dropData.group.position,
                    dragData.group.position,
                    this.lowerPositionValue,
                    this.raisePositionValue,
                );
            }
        },
    },
}
